
import {FC} from 'react';
import {SuccessPage} from "./SuccessPage";

export const AddSuccessPage: FC = () => {
    return (<SuccessPage isUpdate={false} />)
}
